import axios from "axios";

// Same-domain deploys (e.g. single-container on Azure) can leave
// REACT_APP_BACKEND_URL empty — fall back to the page origin so both HTTP and
// WebSocket URLs stay absolute and correct.
const BACKEND = process.env.REACT_APP_BACKEND_URL || (typeof window !== "undefined" ? window.location.origin : "");
export const API = `${BACKEND}/api`;
export const WS_BASE = `${BACKEND.replace(/^http/, "ws")}/api`;

const api = axios.create({ baseURL: API, withCredentials: true, timeout: 60000 });

// Seamless sessions: on a 401, silently refresh the access token once and retry.
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const url = original?.url || "";
    const isAuthCall = url.includes("/auth/login") || url.includes("/auth/refresh") ||
      url.includes("/auth/register") || url.includes("/auth/me");
    if (error.response?.status === 401 && !original._retry && !isAuthCall) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
